import React from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import './styles/index.css'
import App from './App'
import { initSentry, Sentry } from './lib/sentry'
import ServerError from './pages/errors/ServerError'

initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ eventId }) => <ServerError errorId={eventId ?? undefined} />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
